export const isToolsPortal = process.env.REACT_APP_TOOLS_PORTAL === 'true' || window.location.hostname === 'tools.app-breck.com' || window.location.port === '3003';
export const appColors = { f1: '#a578f5', wallet: '#174f43', cooking: '#b94b10' };
export const appNames = { f1: 'F1 predictions', wallet: 'Wallet', cooking: 'Cooking' };
